module.exports = __webpack_public_path__ + "static/DSC_9317-5967cc3965fd93bbf08dd83bd80885be.jpg";